import React from 'react';
import Link from 'next/link';
import Modal from '@common/modal';
import { RouteUrl } from '@utils/routeUtil';
import classnames from 'classnames/bind';
import styles from './modals.module.scss';
const cx = classnames.bind(styles);

interface BookmarkFirstModalProps {
  visible: boolean;
  onClose: () => void;
}

const BookmarkFirstModal = ({ visible, onClose }: BookmarkFirstModalProps) => {
  return (
    <Modal visible={visible}>
      <div className={cx('layer')}>
        <em className={cx('title')}>
          처음으로 관심있는 포지션을
          <br />
          저장하셨네요!
        </em>

        <p className={cx('desc')}>
          북마크한 포지션은 [지원현황] {`>`} 북마크에서
          <br />
          확인할 수 있어요.
        </p>

        <div className={cx('btnArea')}>
          <Link href={RouteUrl.MATCH} legacyBehavior>
            <a className={cx('btn', 'confirm')} role="button">
              북마크한 포지션 보기
            </a>
          </Link>
        </div>

        <a className={cx('btnClose')} role="button" onClick={onClose}>
          <span className={cx('hidden')}>close</span>
        </a>
      </div>
    </Modal>
  );
};

export default BookmarkFirstModal;
